"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMessageStatus = void 0;
var EMessageStatus;
(function (EMessageStatus) {
    EMessageStatus["SENT"] = "SENT";
    EMessageStatus["DELIVERED"] = "DELIVERED";
    EMessageStatus["READ"] = "READ";
})(EMessageStatus || (exports.EMessageStatus = EMessageStatus = {}));
